import ScrollToTopHandler from './ScrollToTopHandler';
export default ScrollToTopHandler;
